/** Loader copy (spec §F copy deck; binding). Keys match the deck for the later string table. */
export const LOADER_COPY = {
  label: "Preparing the map",
  /** {loaded} of {total} MB */
  detail: (loaded: string, total: string) => `${loaded} of ${total} MB`,
  /** After 8 s under 60 %. */
  slow: (total: string) => `The first visit loads about ${total} MB. After that the map opens at once.`,
  /** loader.slow while the manifest (and so the total) has not arrived: the size clause is left out. */
  slowUnsized: "The first visit loads the whole map. After that the map opens at once.",
  error: "The map couldn't load.",
  errorDetail: "Check the connection, then try again.",
  errorAction: "Try again",
  offline: "This map needs a connection the first time it opens.",
  webgl: "This map needs WebGL 2.",
  webglDetail: "Open it in a current version of Chrome, Edge, Safari or Firefox.",
  /** error.generic: a non-essential asset (the deferred DEM) failed; the map carries on. */
  generic: "Something didn't load. The rest of the map still works.",
  /** Client direction: the loader's call to action. */
  enter: "Enter experience",
  place: "Ládera City · Lohegaon, Pune",
} as const;

const MIB = 1024 * 1024;
/** Bytes → "8.4" (one decimal, tabular in the UI). */
export const mb = (bytes: number): string => (Math.max(0, bytes) / MIB).toFixed(1);
/** Bytes → "14" (whole MB, for "about {total} MB"). */
export const mbWhole = (bytes: number): string => String(Math.max(1, Math.round(bytes / MIB)));

/**
 * loader.slow for a total in bytes. The total is stated only once it is known (the manifest has
 * arrived): before that, mbWhole(0) would clamp to "about 1 MB" and understate the download (L4-08).
 */
export const slowNote = (totalBytes: number): string =>
  totalBytes > 0 && Number.isFinite(totalBytes) ? LOADER_COPY.slow(mbWhole(totalBytes)) : LOADER_COPY.slowUnsized;
